import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from 'recharts';

const TicketCheckinChart = ({
  status = { allotment: 100, entered: 0 }
}) => {

  const data = [
    {
      name: 'Checked In',
      value: status.entered
    },
    {
      name: 'Remaining',
      value: status.allotment - status.entered
    }
  ];

  const percent = Math.round((status.entered / status.allotment) * 100);

  return (
    <div style={{ width: '100%', height: 250, position: 'relative' }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey='value'
            startAngle={90}
            endAngle={-270}
            innerRadius={85}
            outerRadius={100}
            stroke='none'
          >
            <Cell fill='#22c55e' />
            <Cell fill='#e5e7eb' />
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pointerEvents: 'none'
        }}
      >
        <div
          style={{
            fontSize: 32,
            fontWeight: 700
          }}
        >
          {status.entered}/{status.allotment}
        </div>

        <div
          style={{
            fontSize: 14,
            color: '#666'
          }}
        >
          {percent}% Checked In
        </div>
      </div>
    </div>
  );
};

export default TicketCheckinChart;